import { useEffect } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
];

export default function Layout() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    return (
        <div className="app-shell">
            <header className="app-header">
                <div className="app-header-start">
                    <Link to="/" className="brand">
                        Libro Diario
                    </Link>
                    <nav className="app-nav">
                        <NavLink to="/" end>
                            {t('nav.companies')}
                        </NavLink>
                        <NavLink to="/messages">{t('nav.messages')}</NavLink>
                    </nav>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div className="lang-switcher">
                        {LANGUAGES.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                className={`lang-switcher-btn ${i18n.language === lang.code ? 'active' : ''}`}
                                onClick={() => i18n.changeLanguage(lang.code)}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                    <UserButton />
                </div>
            </header>
            <main className="app-main">
                <Outlet />
            </main>
        </div>
    );
}
